import DashboardLayout from "../dashboard/layout/DashboardLayout";
import ProvidersTab from "../organization/ProvidersTab";

export default function ProvidersPage() {
  return (
    <DashboardLayout
      title="Providers"
      description="Manage API keys and credentials for various service providers"
      activeItem="Providers"
    >
      <ProvidersTab />
    </DashboardLayout>
  );
}
